function Footer(props) {
  return (
    <footer className="footer">
      <p className="copyleft">COPYLEFT © 2021</p>
      <p className="copyright">COPYRIGHT © 2021</p>
    </footer>
  );
}
export default Footer;
